<template>
  <!-- 由我分配 -->
  <div class="public-sea-clue-assign" v-loading="submitting">
    <el-form
      ref="formRef"
      :model="formData"
      label-width="120px"
      style="padding-top: 20px;"
    >
      <!-- 跟进人 -->
      <el-form-item
        label="跟进人"
        prop="follower"
        :rules="[
          { required: true, message: '请选择跟进人', trigger: 'change' }
        ]"
      >
        <el-select
          v-model="formData.follower"
          placeholder="请选择"
          filterable
          remote
          :remote-method="remoteSearchEmployee"
          :loading="employeeLoading"
          size="small"
          class="form-select"
        >
          <el-option v-for="item in filteredEmployeeOptions" :key="item.workNumber" :label="item.nickName" :value="item.workNumber"></el-option>
        </el-select>
      </el-form-item> 
      <!-- 开始阶段 -->
      <el-form-item label="开始阶段" prop="beginStage">
        <el-select
          v-model="formData.beginStage"
          placeholder="请选择"
          disabled
          size="small"
          class="form-select"
        >
          <el-option label="信息采集" value="S020"></el-option>
        </el-select>
      </el-form-item> 
    </el-form>
  </div>
</template>
 
<script>
  import formFlow from '@/views/DoctorVisitLTC/common/formFlow'
  import { flowCode } from '@/views/DoctorVisitLTC/config/index'
  import request from '@/utils/request'
  export default {
    name: 'PublicSeaClueAssign',
    data() {
      return {
        formData: {
          follower: '', // 跟进人
          beginStage: 'S020' // 开始阶段
        },
        employeeOptions: [],
        employeeLoading: false,
        searchKeyword: '',
        submitting: false // 防止重复提交
      }
    },
    methods: {
      async getEmployeeOptions() {
        const params = {}
        try {
          const res = await request.get('/cluepool/pc/user/all', params, '')
          if(res.code === 200) {
            this.employeeOptions = res.data || []
          } else {
            this.$message.error(res.message)
          }
        } catch (error) {
          console.log('请求员工列表数据请求失败', error)
        }
      },

      // 远程搜索员工
      remoteSearchEmployee(query) {
        if (query !== '') {
          this.employeeLoading = true
          this.searchKeyword = query
          // 模拟远程搜索延迟，优化用户体验
          setTimeout(() => {
            this.employeeLoading = false
          }, 200)
        } else {
          this.searchKeyword = ''
          this.employeeLoading = false
        }
      },
      async submitHandle() {
        // 防止重复提交
        if (this.submitting) {
          return false
        }

        let isFinish = false
        
        try {
          // 表单验证
          const valid = await this.$refs.formRef.validate()
          
          if (!valid) {
            return false
          }

          // 开始提交
          this.submitting = true

          const instanceId = await formFlow.createFlow() 

          const params = {
            flowCode: flowCode, // 流程编号
            flowInstanceId: instanceId, // 流程实例ID
            followAction: 'S020', // 下一步步骤code
            formData: [{
              formCode: 'FR000',
              fieldData: [
                {
                  formFieldCode: 'FR00001',
                  value: [this.currentClueInfo.doctorId]
                },
                {
                  formFieldCode: 'FR00002',
                  value: [this.formData.follower]
                }
              ]
            }]
          }
          const res = await request.post('/cluepool/pc/form/startFlow', params, '')
          if (res.code === 200) {
            isFinish = true
            this.$message.success('分配成功')
          } else {
            this.$message.error(res.message)
          }
          return isFinish
        } catch (error) {
          console.error('由我分配提交失败：', error)
          isFinish = false
          return false
        } finally {
          // 重置提交状态
          this.submitting = false
        }
      }
    },
    created() {
      this.getEmployeeOptions()
    },
    props: {
      currentClueInfo: {
        type: Object,
        default: () => ({})
      }
    },
    computed: {
      // 远程搜索过滤后的员工列表
      filteredEmployeeOptions() {
        if (!this.searchKeyword) {
          return []
        }
        const keyword = this.searchKeyword.toLowerCase()
        return this.employeeOptions.filter(item =>
          (item.nickName || '').toString().toLowerCase().includes(keyword) ||
          (item.workNumber || '').toString().toLowerCase().includes(keyword)
        ).slice(0, 60)
      }
    }
  }
 
</script>

<style scoped lang='less'>

</style>